/**
 * Authentication Configuration
 * Handles OAuth redirect URLs for different environments
 */

export const AUTH_CONFIG = {
  // Supported OAuth redirect ports for local development
  LOCAL_PORTS: [3000, 5173, 5174],
  
  // Production URL
  PRODUCTION_URL: 'https://craftyjoy-demo.netlify.app',
  
  // Get the appropriate redirect URL based on current environment
  getRedirectUrl: (path: string = '/auth/callback'): string => {
    const origin = window.location.origin;
    
    // Handle localhost with different ports
    if (origin.includes('localhost')) {
      // If we're on localhost:3000, use it (OAuth configured port)
      if (origin.includes('localhost:3000')) {
        return `http://localhost:3000${path}`;
      }
      
      // For other localhost ports, try to redirect to port 3000 first
      // This handles the case where OAuth is configured for port 3000
      // but the app is running on a different port
      console.warn(
        `OAuth redirect may fail. Running on ${origin} but OAuth might be configured for localhost:3000.`,
        `Run 'npm run dev:oauth' to use port 3000, or update Supabase redirect URLs.`
      );
    }
    
    // For all other cases, use the current origin
    return `${origin}${path}`;
  },
  
  // Get all possible redirect URLs for documentation
  getAllRedirectUrls: (path: string = '/auth/callback'): string[] => {
    const urls = [
      // Local development URLs
      ...AUTH_CONFIG.LOCAL_PORTS.map(port => `http://localhost:${port}${path}`),
      
      // Production URL
      `${AUTH_CONFIG.PRODUCTION_URL}${path}`,
    ];
    
    // Add current origin if it's not already in the list
    const currentUrl = `${window.location.origin}${path}`;
    if (!urls.includes(currentUrl)) {
      urls.push(currentUrl);
    }
    
    return urls;
  },
  
  // Check if current environment matches OAuth configuration
  isOAuthConfigured: (): boolean => {
    const origin = window.location.origin;
    
    // These are the origins that are likely configured in Supabase
    const configuredOrigins = [
      'http://localhost:3000',
      'https://craftyjoy-demo.netlify.app',
    ];
    
    return configuredOrigins.includes(origin);
  }
};

export default AUTH_CONFIG; 